function convertSchemaToColumns(
  schema,
  formatMessage,
  accessorFunctions,
  accessorFunctionsAdditional = {},
  stickyColumn = false,
) {
  return schema.map((schemaItem, index) => {
    const headerSource = schemaItem.header || schemaItem.label;
    const header = headerSource
      ? formatMessage({
          id: headerSource.localeId,
          defaultMessage: headerSource.defaultMessage,
        })
      : null;

    const hasAccessorFn =
      schemaItem?.accessorFn &&
      typeof accessorFunctions[schemaItem.accessorFn] === 'function';

    return {
      ...(stickyColumn &&
        index === 0 && {
          muiTableHeadCellProps: {
            sx: {
              position: 'sticky',
              left: 0,
              zIndex: 2,
              backgroundColor: '#fff',
            },
          },
          muiTableBodyCellProps: {
            sx: {
              position: 'sticky',
              left: 0,
              zIndex: 1,
              backgroundColor: '#fff',
            },
          },
        }),
      id: schemaItem.name || schemaItem.accessorKey,
      accessorKey: schemaItem.accessorKey,
      header,
      // number which converts to width in pixels
      ...(schemaItem?.size !== undefined && {
        size: schemaItem.size,
      }),
      ...(schemaItem?.enableColumnActions !== undefined && {
        enableColumnActions: schemaItem.enableColumnActions,
      }),
      ...(schemaItem?.enableHiding !== undefined && {
        enableHiding: schemaItem.enableHiding,
      }),
      ...(schemaItem?.enableSorting !== undefined && {
        enableSorting: schemaItem.enableSorting,
      }),
      ...(hasAccessorFn && {
        Cell: props => {
          const {
            row: { original },
          } = props;
          return accessorFunctions[schemaItem.accessorFn](
            original,
            props,
            accessorFunctionsAdditional,
          );
        },
      }),
    };
  });
}

export default convertSchemaToColumns;
